import styled from "theme/libs/styled";

export default styled("div")``;
